import { useFirestore } from "react-redux-firebase";
import NewProjectForm from "./NewProjectForm";

export const pixels = 6;

const CreateNewProject = ({ onNewProjectCreation }) => {
  const firestore = useFirestore();

  function addProjectToFirestore(event) {
    event.preventDefault();
    onNewProjectCreation();

    let newProject = {
      kitName: event.target.kitName.value,
      size: event.target.size.value,
      h: event.target.h.value * pixels,
      walls: [],
      created: Date.now(),
      modified: Date.now(),
      bottomPlate: "FIR",
      eaves: 16,
      due: null,
      stud: 16 * pixels,
      stack: []
    };

    for (let i = 0; i < newProject.size; i++) {
      let newWall = { 
        pixels: pixels,
        twoByW: 1.5 * pixels,
        twoByH: 3.5 * pixels,
        w: 48 * pixels,
        h: event.target.h.value * pixels,
        stud: 24 * pixels,
        window1: {
          windowW: 42 * pixels,
          windowH: 42 * pixels,
          sill: 24 * pixels,
          header: 5.5 * pixels,
          headerAmount: 0,
          windowType: "FIXED",
          placement: 0,
          tempered: "STANDARD",
        },
        window2: {
          windowW: 42 * pixels,
          windowH: 42 * pixels,
          sill: 24 * pixels,
          header: 5.5 * pixels,
          headerAmount: 0,
          windowType: "FIXED",
          placement: 0,
          tempered: "STANDARD",
        },
        windows: 0,
        windowW: 42 * pixels,
        windowH: 42 * pixels,
        sill: 24 * pixels,
        header: 5.5 * pixels,
        headerAmount: 0,
        windowType: 0,
        placement: 0,
        id: i,
        notes: "",
        windowEdgeTrim: false,
        cornerTrim: false,
        kitName: event.target.kitName.value,
        doors: 0,
        doorH: 82 * pixels,
        doorW: 38 * pixels,
        frenchDoor: null,
        frenchHeader: 9.25 * pixels,
        frenchHeaderAmount: 0,
        frenchW: "5ft",
        stackPos: i,
      };
      newProject.walls.push(newWall);
    }
    
    

    return firestore.collection("projects").add(newProject);
  }

  return (
    <>
      <NewProjectForm
        formSubmitHandler={addProjectToFirestore}
        buttonText="submit"
      />
    </>
  );
};

export default CreateNewProject;
